import http from '@/services/http';

//-------------------- GETS ----------------------

export async function getCurrencies(filter) {
  try {
    let res = await http.get('/Currency');
    if (filter) {
      return res.data.data.filter(item => item[filter]);
    } else {
      return res.data.data;
    }
  } catch (e) {
    console.log(e);
  }
}
